<div *ngIf="selectedKeishaHibetsuFile">
  <div fxLayout="row" fxLayoutGap="10px">
    <div fxLayout="column" style="width: 50%">
      <div *ngFor="let floor of [1,2]">
        <h2>{{floor}}階</h2>
        <div fxLayout="row">
          <div *ngFor="let amPm of ['AM','PM']">
            <h5 *ngIf="amPm === 'AM'">午前</h5>
            <h5 *ngIf="amPm === 'PM'">午後</h5>
            <table class="keisha-hibetsu-kiroku">
              <thead>
              <tr>
                <th></th>
                <th>最高</th>
                <th>現在</th>
                <th>最低</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let position of ['Front', 'Middle', 'Rear']">
                <td *ngIf="position==='Front'">前</td>
                <td *ngIf="position==='Middle'">中</td>
                <td *ngIf="position==='Rear'">後</td>
                <td *ngFor="let status of ['high', 'current', 'low']">
                    <span [innerText]="selectedKeishaHibetsuFile.temperature[status + temperature + floor + position + amPm]
                                       ? selectedKeishaHibetsuFile.temperature[status + temperature + floor + position + amPm] : ''">
                    </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div><br>
      </div>
    </div>
    <div fxLayout="column">
<!--      <div *ngIf="selectedShiyoulotHibetsuFile">-->
<!--        <h2>斃死・淘汰羽数</h2>-->
<!--        <table class="keisha-hibetsu-kiroku">-->
<!--          <thead>-->
<!--          <tr>-->
<!--            <th *ngFor="let propertyName of heishiToutaProperties| keyvalue: commonService.originalOrder">{{propertyName.value}}</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr>-->
<!--            <td *ngFor="let propertyName of heishiToutaProperties| keyvalue: commonService.originalOrder">{{selectedShiyoulotHibetsuFile[propertyName.key]}}</td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->
      <div style="width: 223px">
        <h2>本日の作業</h2>
        <div class="today-operation">
          {{selectedKeishaHibetsuFile.operation}}
        </div>
      </div>
    </div>
  </div>
</div>
